import type { AdminLocale } from '@/i18n';
import type { MessageKey } from '@/i18n/messages';
import { count } from '@/lib/format';

/** "1 item", "3 items" — one is its own phrase in both languages. */
export function itemCount(
  units: number,
  t: (key: MessageKey, values?: Record<string, string | number>) => string,
  locale: AdminLocale,
): string {
  return units === 1 ? t('orderItemOne') : t('orderItemCount', { count: count(units, locale) });
}
